import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Grid } from '@mui/material';
import {
  DRIVER_STATUS_OPTIONS,
  STATUS_OPTIONS_ADMIN,
  showErrorTost,
  showSuccessTost,
  statusModalArray,
} from 'src/constants';
import MapRender from 'src/components/maps/mapRender';
import BookingForm from 'src/components/form/bookingForm';
import { processArray } from 'src/helper';
import TabTitle from 'src/components/tabTitle/tabTitle';
import PageHeader from 'src/components/pageHeader/PageHeader';
import CustomSelectField from 'src/components/formFields/selectField';
import { GET_DRIVER, GET_SETTING, UPDATE_BOOKING } from 'src/apiService/apiDeclaration';
import { useLocation } from 'react-router-dom';
import { USER_ROLES } from 'src/config/enum';
import { useModal } from 'src/hooks/useModal';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { useSelector } from 'react-redux';

export default function BookingDetailsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const [coordinates, setCoordinates] = useState([data.startPoint, ...data.middlePoints, data.endPoint]);
  const [distance, setDistance] = useState();
  const [priceData, setPriceData] = useState();
  const [bookingLoading, setBookingLoading] = useState(false);
  const [userId, setUserId] = useState();
  const [driverOptions, setDriverOptions] = useState();
  const { setDialogData, handleModalClose } = useModal();

  const statusMapping = {
    'Pending Review': 'pending-review',
    Upcoming: 'upcoming',
    'In Progress': 'in-progress',
    Rejected: 'rejected',
    Cancelled: 'cancelled',
    Failed: 'failed',
    'Wrapping Up': 'wrapping-up',
    Completed: 'completed',
  };

  const defaultValue = statusMapping[data.status];
  const [status, setStatus] = useState(defaultValue);
  const getData = async () => {
    try {
      const price = await GET_SETTING();
      setPriceData(price.data);
      const { data } = await GET_DRIVER();
      const updatedDriverOptions = data?.map((item) => {
        return { label: item.name, value: item._id };
      });
      setDriverOptions(updatedDriverOptions);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const onBookingUpdate = async (data) => {
    setBookingLoading(true);
    const { origin: startPoint, destination: endPoint, inBetweenArray: middlePoints } = processArray(coordinates);
    const body = {
      ...data,
      startPoint,
      endPoint,
      middlePoints,
      dateTime: new Date(data.dateTime),
      status: status,
      userId,
    };
    try {
      const res = await UPDATE_BOOKING(data?._id, body);
      if (res?.data) {
        showSuccessTost(res.message);
        setBookingLoading(false);
        navigate(-1);
      }
    } catch (err) {
      console.log(err);
      showErrorTost('Error in updating booking!!');
      setBookingLoading(false);
    }
  };
  const { user } = useSelector((state) => state.auth);
  const statusOptions = user.role === USER_ROLES.ADMIN ? STATUS_OPTIONS_ADMIN : DRIVER_STATUS_OPTIONS;
  const handleChange = (e) => {
    const selected = statusModalArray[e.target.value];
    if (selected !== defaultValue) {
      setDialogData({
        showModal: true,
        description: selected.message,
        child: selected.canSelect ? (
          <Grid container sx={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1rem', gap: 2 }} xs={12}>
            <LoaderButton
              buttonText={'Yes'}
              onClick={() => {
                setStatus(e.target.value);
                handleModalClose();
              }}
            />
            <LoaderButton
              buttonText={'No'}
              sx={{
                background: 'red',
                '&:hover': {
                  background: '#e00000',
                },
              }}
              onClick={() => {
                setStatus(defaultValue);
                handleModalClose();
              }}
            />
          </Grid>
        ) : (
          <Grid container sx={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1rem', gap: 2 }} xs={12}>
            <LoaderButton
              buttonText={'Cancel'}
              onClick={() => {
                setStatus(defaultValue);
                handleModalClose();
              }}
            />
          </Grid>
        ),
      });
    }
  };

  return (
    <Container>
      <Grid container spacing={2}>
        <TabTitle title={'Booking Details'} />
        <Grid item xs={12}>
          <PageHeader pageTitle={'Booking Details'} />
        </Grid>
        <Grid item mb={12} xs={12}>
          <>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} sm={6} md={3}>
                <CustomSelectField
                  value={status}
                  onChange={(e) => (user.role === USER_ROLES.ADMIN ? setStatus(e.target.value) : handleChange(e))}
                  label={'Status'}
                  optionsArray={statusOptions}
                />
              </Grid>
              {driverOptions && user.role === USER_ROLES.ADMIN && (
                <Grid item xs={12} sm={6} md={3}>
                  <CustomSelectField
                    value={data.userId?._id}
                    onChange={(e) => setUserId(e.target.value)}
                    label={'Driver'}
                    optionsArray={driverOptions}
                  />
                </Grid>
              )}
            </Grid>

            {coordinates?.length > 1 && (
              <MapRender
                disabled={user.role === USER_ROLES.EMPLOYEE}
                setDistance={setDistance}
                coordinates={coordinates}
                setCoordinates={setCoordinates}
              />
            )}
            <BookingForm
              disabled={user.role === USER_ROLES.EMPLOYEE}
              coordinates={coordinates}
              data={data}
              onSubmit={onBookingUpdate}
              distance={distance}
              priceData={priceData && priceData}
              loading={bookingLoading}
              length={coordinates?.length}
            />
          </>
        </Grid>
      </Grid>
    </Container>
  );
}
